import * as Yup from "yup";

const enquiryFormSchema = Yup.object({
    product_string : Yup.string().required('Product is required!'),
    country_string : Yup.string().required('Country is required!'),
    quantity : Yup.number().required('Quantity is required!').nullable().typeError('quantity should be a valid number!'),
    price : Yup.number().required('Price is required!').nullable().typeError('Price should be a valid number!'),
    required_manufacturer : Yup.string().required('Manufacturer is required!'),
    expected_certificates : Yup.array().min(1, 'Please select at least 1 certificate!'),
    pharmacopoeia_grades : Yup.array().min(1, 'Please select at least 1 grade!'),
    expected_date : Yup.date().required('Date is required!').nullable().typeError('Must be a valid date!'),
    shipping_terms : Yup.string().required('Shipping Terms is required!'),
});

export const enquiryFormWithoutLoginSchema = Yup.object({
    created_by_name : Yup.string().required('This field is required!'),
    created_by_email : Yup.string().email().required('This field is required!'),
    created_by_phone : Yup.number().required('This field is required!').nullable().typeError('Please enter a valid phone number!'),
    created_by_company_name : Yup.string().required('This field is required!'),
})

export const ShortEnquiryFormSchema = Yup.object({
    product_string : Yup.string().required('Product is required!'),
    quantity : Yup.number().required('Quantity is required!').nullable().typeError('quantity should be a valid number!'),
    message : Yup.string().required('Message is required!')
})

export default enquiryFormSchema